module.exports = __webpack_public_path__ + "img/survey-logo.4e47fb7c.svg";